import { Image } from '@cian/ui-kit/image';

interface INewbuildingImageProps {
  name: string;
  imageUrl: string;
  isRedesign?: boolean;
}

export function NewbuildingImage({ imageUrl, name, isRedesign = false }: INewbuildingImageProps) {
  return (
    <Image
      data-testid="newbuilding-image"
      preloader
      src={imageUrl}
      alt={name}
      width="100%"
      height={isRedesign ? 160 : 180}
      borderRadius={isRedesign ? '16px' : 0}
      objectFit="cover"
    />
  );
}
